/**
 * Types de Metrik (PRED-3288) : liste fermée, miroir de MetrikTypeEnum back.
 * Un motif Metrik porte un ou plusieurs de ces types ; le ticket compétence ne propose
 * que les motifs typés Compétence.
 */
export enum MetrikTypeEnum {
  EQUIPMENT = 'Equipement',
  BUILDING = 'Bâtiment',
  ENERGY = 'Energie',
  COMPETENCE = 'Compétence',
}

export const metrikTypeOptions = Object.values(MetrikTypeEnum);
